import Logo from '../../ui/Logo/Logo';

export default function Navbar(conference = {}) {

    const layout =
        conference.settings?.site?.layout || 'onepage';
	
	 const registrationEnabled =
        conference.settings?.registration?.show === true;
	
	const programmeEnabled =
		conference.settings?.programme?.show === true;
    
    const isVite =
        window.location.pathname.startsWith('/themes/pierogy2/vite');

    /*
     * ONEPAGE
     * --------
     * Wszystkie linki są kotwicami.
     */
    function anchorUrl(anchor) {
        return `#${anchor}`;
    }

    /*
     * LANDING
     * -------
     * Osobne strony.
     */
    function pageUrl(page) {
        if (isVite) {
            return `/themes/pierogy2/vite/${page}`;
        }

        return `/${page}`;
    }

    function navigationLink(page, label) {

        if (layout === 'landing') {
            return `
                <a href="${pageUrl(page)}">
                    ${label}
                </a>
            `;
        }

        return `
            <a href="${anchorUrl(page)}" data-scroll>
                ${label}
            </a>
        `;
    }

    const homeUrl =
        layout === 'landing'
            ? (isVite
                ? '/themes/pierogy2/vite/'
                : '/')
            : '#home';

    const registerUrl =
        layout === 'landing'
            ? pageUrl('registration')
            : '#register';

    return `
        <header class="navbar">

            <div class="container navbar__container">

                <a
                    href="${homeUrl}"
                    class="navbar__brand"
                >
                    ${Logo()}
                </a>

                <div class="navbar__right">

                    <nav class="navbar__menu">

                        <a
                            href="${homeUrl}"
                            ${layout === 'onepage'
                                ? 'data-scroll'
                                : ''}
                        >
                            Home
                        </a>

                      ${false ? navigationLink('about', 'About') : ''}

                        ${navigationLink('speakers', 'Speakers')}

                        ${navigationLink('committee', 'Organizers')}

                        ${programmeEnabled
						? navigationLink('programme', 'Programme')
						: ''}

                        ${navigationLink('venue', 'Venue')}

                        
                    </nav>

                   ${registrationEnabled ? `
					<a
						class="navbar__register"
						href="${registerUrl}"
					>
						Register
					</a>
				` : ''}

                    

                    <button
                        class="navbar__toggle"
                        type="button"
                        aria-label="Open menu"
                    >
                        ☰
                    </button>
                    
                    <button
                        id="theme-toggle"
                        class="navbar__theme"
                        type="button"
                        aria-label="Toggle dark mode"
                    >
                        ☀️
                    </button>

                </div>

            </div>

        </header>
    `;
}
